import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SellerDashboardModule } from './seller-dashboard/seller-dashboard.module';

@NgModule( {
    imports: [
        CommonModule,
        SellerDashboardModule
    ],
    declarations: []
} )
export class DashboardModule {
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/dashboard/dashboard.module.ts